import { SET_PLANS } from "./actionTypes";

export default (plans) => ({
  type: SET_PLANS,
  payload: {
    plans,
  },
});
